import React from 'react';

import { locale } from '@trqk/utils';
import { IconX, IconSparkles } from '@trqk/components';

export const HowIngestionWorks = ({
    close,
}: RenderTooltipMessageProps): JSX.Element => (
    <div className="text-tertiary-500 bg-white pb-4">
        <div className="flex justify-end px-2 pt-2">
            <IconX
                addClasses="respond-to-mouse"
                width={16}
                fillColor="tertiary-400"
                handleClick={close}
            />
        </div>
        <div className="px-8 mt-2">
            <div className="font-semibold text-lg mb-2">
                {locale.enUS.HELP.HOW_INGESTION_WORKS.UPLOADS_HAVE_TWO_STAGES}
            </div>
            <div className="text-sm my-4">
                <ol className="list-decimal leading-loose">
                    <li>
                        {locale.enUS.HELP.HOW_INGESTION_WORKS.STAGES.STAGE_1}
                    </li>
                    <li>
                        {
                            locale.enUS.HELP.HOW_INGESTION_WORKS.STAGES.STAGE_2
                                .PART_1
                        }
                        &nbsp;
                        <span className="font-semibold">
                            {
                                locale.enUS.HELP.HOW_INGESTION_WORKS.STAGES
                                    .STAGE_2.PART_2
                            }
                        </span>
                    </li>
                </ol>
            </div>
            <hr />
            <div className="flex items-center mt-4">
                <IconSparkles fillColor="tertiary-400" height={20} />
                <div className="ml-2 font-semibold italic">
                    {locale.enUS.HELP.HOW_INGESTION_WORKS.INGESTION_IS_COMPLEX}
                </div>
            </div>
            <div className="mt-2 leading-loose">
                {locale.enUS.HELP.HOW_INGESTION_WORKS.WHY_INGESTION_IS_COMPLEX}
            </div>
        </div>
    </div>
);
